var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.label)?_c('v-checkbox',{staticClass:"mb-4",attrs:{"label":_vm.label,"disabled":_vm.schema.removeable},model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }